import React from 'react'
import GenerateLink from './generatepaymentlinkPopup'
import GenerateLinkAbhicash from './generatepaymentlinkPopupAbhicash'
import GeneratepaymentlinkPopupDreamSupporter from './generatepaymentlinkPopupDreamSupporter'
import { ABHICASH_LIKE, CHECK_COMPANY_TENANT, Company_DATA, DREAM_SUPPORTER_ONLY } from '../../../../layouts/MainTenantconfig'
export default function Main({ openGenerateLink, emiDetail, userDetail, admin, tenant }) {
    return (
        <>
            {
                CHECK_COMPANY_TENANT(DREAM_SUPPORTER_ONLY) ?
                    <GeneratepaymentlinkPopupDreamSupporter
                        openGenerateLink={openGenerateLink}
                        emiDetail={emiDetail}
                        userDetail={userDetail}
                        admin={admin}
                        tenant={tenant}
                    />
                :
                CHECK_COMPANY_TENANT(ABHICASH_LIKE) && !CHECK_COMPANY_TENANT(DREAM_SUPPORTER_ONLY) ?
                    <GenerateLinkAbhicash
                        openGenerateLink={openGenerateLink}
                        emiDetail={emiDetail}
                        userDetail={userDetail}
                        admin={admin}
                        tenant={tenant}
                    />
                    :
                    <GenerateLink
                        openGenerateLink={openGenerateLink}
                        emiDetail={emiDetail}
                        userDetail={userDetail}
                        admin={admin}
                        tenant={tenant}
                    />
            }
        </>
    )
}
